"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var path_parser_1 = require("path-parser");
var Button_1 = __importDefault(require("react-bootstrap/Button"));
var AcTableActionCell_module_scss_1 = __importDefault(require("./AcTableActionCell.module.scss"));
var AcActionDropdown_1 = require("../dropdown/AcActionDropdown");
exports.acTableActionCellConfigs = {
    reply: {
        icon: 'far fa-reply',
    },
    view: {
        icon: 'far fa-eye',
    },
    edit: {
        icon: 'far fa-edit',
    },
    dropdown: {
        icon: 'fas fa-ellipsis-v',
    },
    download: {
        icon: 'far fa-download',
    },
};
exports.AcTableActionCell = function (props) {
    var _a = props.actions, actions = _a === void 0 ? [] : _a, data = props.data, functionContext = props.functionContext;
    var history = react_router_dom_1.useHistory();
    var buttons = actions.map(function (action, index) {
        var config = exports.acTableActionCellConfigs[action.type];
        if (!config) {
            config = {};
        }
        var onClick = function () {
            if (action.onClick) {
                action.onClick(data ? data : {}, functionContext ? functionContext : {});
            }
            else if (action.path) {
                var pathParser = new path_parser_1.Path(action.path);
                var path = pathParser.build(data);
                history.push(path);
            }
        };
        if (action.type === 'dropdown') {
            return (react_1.default.createElement(AcActionDropdown_1.AcActionDropdown, { disableDropdownIcon: true, dropdownClassName: "mx-1", key: index, functionContext: functionContext, id: "eFax_dropdown" //FIXME
                , data: data, title: react_1.default.createElement("i", { className: "ac-table--no-row-click " + config.icon + " " + AcTableActionCell_module_scss_1.default.button + " fs-17", style: { width: '20px' } }), align: "alignRight", actions: action.dropdownActions }));
        }
        var hidden;
        if (typeof action.hide === 'function') {
            hidden = action.hide(data || {}, functionContext || {});
        }
        else {
            hidden = action.hide;
        }
        var disabled;
        if (typeof action.disabled === 'function') {
            disabled = action.disabled(data || {}, functionContext || {});
        }
        else {
            disabled = action.disabled;
        }
        return (react_1.default.createElement(Button_1.default, { hidden: hidden, size: "sm", key: index, onClick: onClick, className: "ac-table--no-row-click mx-1 " + (action.path ? AcTableActionCell_module_scss_1.default.clickable : '') + " " + AcTableActionCell_module_scss_1.default.button, variant: "link", title: action.tooltipText, disabled: disabled },
            react_1.default.createElement("i", { className: "fs-17 " + config.icon + " " + AcTableActionCell_module_scss_1.default.actionBtnIcon })));
    });
    return react_1.default.createElement("div", { className: "d-flex flex-row justify-content-end" }, buttons);
};
exports.AcTableActionCell.displayName = 'AcTableActionCell';
//# sourceMappingURL=AcTableActionCell.js.map